import styled from 'styled-components/macro';
import { Platforms } from 'src/App/Types/app.types';

export const LayoutContain = styled.div<{ platform: Platforms }>`
	background: linear-gradient(179.58deg, #631b78 -29.11%, #262543 38.02%), #262543;

	${({ platform }) =>
		platform === Platforms.MOBILE
			? `
	`
			: platform === Platforms.PANEL
			? `
	`
			: platform === Platforms.COMPONENT
			? `
	`
			: platform === Platforms.VIDEO
			? `
		background: transparent;
		`
			: platform === Platforms.WEB
			? `
	`
			: ``}
`;
